import { datadogRum } from '@datadog/browser-rum';

import { Errors } from '../types/errors';

export const addError = (errorName: Errors, error: Error | unknown, context?: Record<string, unknown>) => {
  datadogRum.addError(error, { errorName, ...context });
};
